import { render, staticRenderFns } from "./LoginLocal.vue?vue&type=template&id=116e9c7e&"
import script from "./LoginLocal.vue?vue&type=script&lang=js&"
export * from "./LoginLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports